import { pmnFunctionOperations } from './constants';

export const ruleFromCode = (ruleStore, code) => ruleStore.find((o) => o.code === code);

export const ruleFromDictionaryFieldRule = (ruleStore, pmnField) => {
  let rule = null;
  if (!pmnField) {
    return null;
  }
  if (pmnField.operation === pmnFunctionOperations.GENERALISE) {
    rule = ruleStore.find((o) => o.code === pmnField.function);
  } else {
    rule = ruleStore.find((o) => o.code === pmnField.operation);
  }
  return rule;
};

export const validRuleFromFunction = (pmnField, fieldType, store) => {
  const rule = ruleFromDictionaryFieldRule(store, pmnField);
  if (rule && rule.types && !rule.types.includes(fieldType)) {
    return null;
  }
  return rule;
};

export const ruleToFieldProps = (pmnRule) => {
  let props = null;
  if (pmnRule) {
    const { operation } = pmnRule;
    props = { function: null, operation };
    if (operation === pmnFunctionOperations.GENERALISE) {
      props.function = pmnRule.code;
    }
  }
  return props;
};
